module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-three"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("\n      8. Paid Media annual budget\n    ")]), _vm._v(" "), _c('HotTable', {
    ref: "paidMediaId",
    attrs: {
      "root": _vm.paidMediaId,
      "settings": _vm.paidMedia
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'invalid-field': (!_vm.validate['step3'])
    },
    attrs: {
      "id": _vm.checkValidate = _vm.validate['step3']
    }
  }, [_c('p', {
    staticClass: "error-msg"
  }, [_vm._v("Please add valid entry in above table.")])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-119ac7aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Model-three.vue
// module id = 307
// module chunks = 1